import * as z from "zod";

import { maintenancePlanCodeWithGroupSchema } from "./maintenance-plan-code-with-group";
import { maintenancePlanSchema } from "./maintenance-plan";
import { propertyPartWithPropertySchema } from "./property-part-with-property";

export const maintenancePlanWithDetailsSchema = maintenancePlanSchema.extend({
  maintenancePlanCode: maintenancePlanCodeWithGroupSchema,
  propertyPart: propertyPartWithPropertySchema,
  lastActionDate: z.coerce.date().optional(),
});

export type MaintenancePlanWithDetails = z.infer<
  typeof maintenancePlanWithDetailsSchema
>;
